import { AxiosInstance } from 'axios';
import { get, post, del } from '../hooks/useAxiosPrivate';
import { ApiKeyEntity } from '../state/apiKeys/types';

const companyApiKeysUrl = (companyId: string) =>
  `/api/v1/company/${companyId}/api-keys`;

const ApiKeysApi = {
  getApiKeys: async (
    axios: AxiosInstance,
    companyId: string
  ): Promise<{ entities: ApiKeyEntity[]; totalPages: number }> => {
    const response = await get(axios, companyApiKeysUrl(companyId));
    return response.data;
  },
  createApiKey: async (
    axios: AxiosInstance,
    name: string,
    companyId: string
  ): Promise<{ apiKey: ApiKeyEntity; key: string }> => {
    const response = await post(axios, companyApiKeysUrl(companyId), {
      name,
    });
    return response.data;
  },
  revokeApiKey: async (
    axios: AxiosInstance,
    apiKeyId: string,
    companyId: string
  ): Promise<ApiKeyEntity> => {
    const response = await del(
      axios,
      `${companyApiKeysUrl(companyId)}/${apiKeyId}`
    );
    return response.data;
  },
};

export default ApiKeysApi;
